var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlusSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-plus-solid",
    d: "M3.6,4.8A4.8,4.8,0,1,1,8.4,9.6,4.8,4.8,0,0,1,3.6,4.8ZM0,18.086A6.685,6.685,0,0,1,6.686,11.4h3.428A6.685,6.685,0,0,1,16.8,18.086,1.114,1.114,0,0,1,15.686,19.2H1.114A1.114,1.114,0,0,1,0,18.086ZM18.9,11.7V9.3H16.5a.9.9,0,0,1,0-1.8h2.4V5.1a.9.9,0,1,1,1.8,0V7.5h2.4a.9.9,0,0,1,0,1.8H20.7v2.4a.9.9,0,1,1-1.8,0Z",
    fill: "#f5f7f9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusSolid);
export default __webpack_public_path__ + "static/media/user-plus-solid.97e8be228a300ea182a6ca946ccdac83.svg";
export { ForwardRef as ReactComponent };